import React, { createContext, useContext } from 'react';

import { MobilePlansEditableContentProps } from '../../MobilePlansEditConfig';

export const MobilePlansEditableContentContext =
  createContext<MobilePlansEditableContentProps>({});

export const useMobilePlansContent = () => {
  const context = useContext(MobilePlansEditableContentContext);

  if (context === undefined) {
    throw new Error(
      'useMobilePlansContent must be used within a MobilePlansEditableContentProvider',
    );
  }
  return context;
};

export const MobilePlansEditableContentProvider: React.FC<{
  value: MobilePlansEditableContentProps;
}> = ({ value, children }) => {
  return (
    <MobilePlansEditableContentContext.Provider value={{ ...value }}>
      {children}
    </MobilePlansEditableContentContext.Provider>
  );
};

export default MobilePlansEditableContentProvider;
